const $ = require( 'jquery' );
const hljs = require('highlight.js');


$(document).ready(function() {
	hljs.highlightAll();
});